import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations as en } from '../translations/en';
import { translations as es } from '../translations/es';
import { motion } from 'framer-motion';

const translations = { en, es };

const FAQ = () => {
  const { language } = useLanguage();
  const t = translations[language];

  // Add state for question category
  const [category, setCategory] = useState('foreigner');

  // Use new translation keys if available, fallback to questions
  const foreignerQuestions = t.faq.foreignerQuestions || t.faq.questions;
  const domesticQuestions = t.faq.domesticQuestions || t.faq.questions;

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <div className="relative h-[40vh] min-h-[300px]">
        <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: 'url("/images/flowers3.jpg")' }}>
          <div className="absolute inset-0 bg-black opacity-40"></div>
        </div>
        <div className="relative h-full flex items-center">
          <div className="max-w-4xl mx-auto px-4 text-center">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
                {t.faq.pageTitle}
              </h1>
              <p className="text-lg md:text-xl text-white max-w-2xl mx-auto">
                {t.faq.pageDescription}
              </p>
            </motion.div>
          </div>
        </div>
      </div>

      {/* Note for mixed couples */}
      <div className="max-w-3xl mx-auto px-4 pt-8 text-center text-[#bfa76a] font-medium text-base">
        {language === 'en'
          ? 'If one of you is from Mexico and the other is from another country, please refer to the International Couples section.'
          : 'Si uno de ustedes es mexicano y el otro de otro país, consulta la sección de Parejas Internacionales.'}
      </div>

      {/* Category Tabs */}
      <div className="max-w-3xl mx-auto px-4 pt-8 flex gap-4 justify-center">
        <button
          className={`px-6 py-2 rounded-full font-semibold text-base transition-colors duration-200 ${category === 'foreigner' ? 'bg-[#bfa76a] text-white' : 'bg-[#f5f0e6] text-[#181c24]'}`}
          onClick={() => setCategory('foreigner')}
        >
          {t.faq.foreignerTab || (language === 'en' ? 'For Foreigners' : 'Para Extranjeros')}
        </button>
        <button
          className={`px-6 py-2 rounded-full font-semibold text-base transition-colors duration-200 ${category === 'domestic' ? 'bg-[#bfa76a] text-white' : 'bg-[#f5f0e6] text-[#181c24]'}`}
          onClick={() => setCategory('domestic')}
        >
          {t.faq.domesticTab || (language === 'en' ? 'For Domestic Couples' : 'Para Nacionales')}
        </button>
      </div>

      {/* FAQ List */}
      <div className="max-w-3xl mx-auto px-4 py-12">
        <div className="space-y-8">
          {(category === 'foreigner' ? foreignerQuestions : domesticQuestions).map((item, idx) => (
            <div key={idx} className="bg-[#f9f7f3] rounded-xl shadow p-6">
              <h2 className="text-xl font-semibold mb-2 text-[#bfa76a]">{item.q}</h2>
              <p className="text-gray-700 text-base">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;
// Note: Add the needed translation keys to en.js and es.js under a 'faq' section, including an array of questions with q/a pairs. 